/**
 * MyAccountMenuUtils comprises utility functions used in 'My Account' Page internal menu.
 *
 * @class MyAccountMenuUtils
 * @memberof Mojito.Applications.Sports.Pages.MyAccountPage
 * @private
 */
export default class MyAccountMenuUtils {
    static findItem(menuSections, selectedItemId, partId) {
        if (!selectedItemId) {
            return;
        }

        if (!Array.isArray(menuSections)) {
            return;
        }

        const menuSectionsItems = menuSections.flatMap(section => section.items);
        const partIdItem = menuSectionsItems.find(({ id }) => id === partId);
        const selectedItem = menuSectionsItems.find(({ id }) => id === selectedItemId);

        // we should use partIdItem, if it exists and is a valid route to make proper back button rendering in nested routes.
        return partIdItem || selectedItem;
    }
}
